<div class="wrapper shadowed">
    <h4>Liste des appels</h4>
    <!-- <div class="row">
    <div class="col-sm-2"><button class="btn btn-info btn-block">Vue Facturation</button></div>
    <div class="col-sm-3"><button class="btn btn-danger btn-block">Interventions à prévoir</button></div>
    <div class="col-sm-2"><button class="btn btn-success btn-block">Analyse détaillée</button></div>
</div> -->
    <button class="btn btn-outline-dark" (click)="clickCall(-1,'Nouvelle intervention','edit')">Nouvelle
        intervention</button>
    <app-gmao-spinner *ngIf="!nbAppels"></app-gmao-spinner>
    <ng-container *ngIf="nbAppels">
        <pagination-controls class="custom-pagination" style="text-align: center;" (pageChange)="pageChange($event)"
            previousLabel="Précédent" nextLabel="Suivant"></pagination-controls>
        <p style="text-align: center;">{{ nbAppels.sav_suivis_count }} appels</p>
    </ng-container>
    <div class="table-responsive">
        <table class="table table-striped">
            <tbody>
                <ng-container *ngIf="appels">
                    <ng-container *ngIf="nbAppels">
                        <ng-container *ngFor="let appel of appels.suivis | paginate : {  itemsPerPage: 30,
                            currentPage: p,
                            totalItems: nbAppels.sav_suivis_count }">
                            <tr (click)="clickCall(appel.id_sav_suivi,appel.nom_installation,'read')">
                                <td>{{ appel.date_debut }}</td>
                                <td>{{ appel.nom_installation}}</td>
                                <td>
                                    <p *ngFor="let inter of appel.intervenants"> {{ inter.intervenant }}</p>
                                </td>
                                <ng-container *ngFor="let action of appel.actions">
                                    <td>{{ action.nom_action }}</td>
                                </ng-container>
                                <ng-container *ngIf="appel.state">
                                    <td>
                                        <b>
                                            <strong *ngIf="appel.state.call_state" class="ok">OK</strong>
                                            <strong *ngIf="!appel.state.call_state" class="nok">NOK</strong>
                                        </b>
                                        par {{appel.state.user_login}}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>